module.exports = __webpack_public_path__ + "img/6.af5e7a22.png";